import React from 'react';

import TooltipWrapper from 'app/shared/components/common/TooltipWrapper';
import PropTypes from 'prop-types';

import { InfoIcon } from '../../coreDesignSystem/icons';

import { tooltipStyles } from './RecordingFeesData.styles';

const FeeInfoIcon = ({ content }) => {
  return (
    <TooltipWrapper title={content} tooltipSx={tooltipStyles}>
      <span className="px-4 cursor flex items-center">
        <InfoIcon size={16} />
      </span>
    </TooltipWrapper>
  );
};

FeeInfoIcon.propTypes = {
  content: PropTypes.node.isRequired,
};

export default FeeInfoIcon;
